import { render, staticRenderFns } from "./commitment.vue?vue&type=template&id=553aa029&scoped=true&"
import script from "./commitment.vue?vue&type=script&lang=js&"
export * from "./commitment.vue?vue&type=script&lang=js&"
import style0 from "./commitment.vue?vue&type=style&index=0&id=553aa029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553aa029",
  null
  
)

export default component.exports